import React, { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import FormHeader from "@/components/FormHeader";
import Modal from "@/components/Modal";
import api from "@/lib/axios";
import { DataSiswa } from "@/types";
import { AxiosError } from "axios";
import { Loader2, MoreHorizontal } from "lucide-react";
import toast from "react-hot-toast";
import { IoLogIn } from "react-icons/io5";
import { useMutation } from "@tanstack/react-query";
import FormEditNIK from "./FormEditNIK";
import FormInsertPendaftaran from "./FormInsertPendaftaran";

const loginBypassMahasiswa = async (email: string) => {
  const response = await api.post("/auth/login-bypass-mahasiswa", {
    email,
  });

  return response?.data;
};

export default function Actions({ row }: { row: DataSiswa }) {
  const [selectedRow, setSelectedRow] = useState<DataSiswa | null>(null);
  const [showConfirmationLoginBack, setShowConfirmationLoginBack] =
    useState(false);
  const [showEditNIK, setShowEditNIK] = useState(false);
  const [showInsertPendaftaran, setShowInsertPendaftaran] = useState(false);

  const { mutate, isPending } = useMutation({
    mutationFn: loginBypassMahasiswa,
    onSuccess: (data) => {
      toast.success(data?.message || "Success.");
      window.location.assign("/");
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
    },
  });

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowConfirmationLoginBack(true);
                setSelectedRow(row);
              }}
            >
              Login Sebagai Siswa
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                setShowEditNIK(true);
                setSelectedRow(row);
              }}
            >
              Edit NIK
            </DropdownMenuItem>

            <DropdownMenuItem
              onClick={() => {
                setShowInsertPendaftaran(true);
                setSelectedRow(row);
              }}
            >
              Insert Pendaftaran Pasca
            </DropdownMenuItem>

            <DropdownMenuSeparator />
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal
        show={showConfirmationLoginBack}
        onClose={() => setShowConfirmationLoginBack(false)}
      >
        <FormHeader
          title={`Login sebagai ${selectedRow?.nama_lengkap}`}
          description={`Apakah anda yakin akan login sebagai ${selectedRow?.nama_lengkap}?`}
          icon={<IoLogIn />}
        />
        <div className="mt-5 flex gap-3">
          <Button
            variant={"outline"}
            onClick={() => setShowConfirmationLoginBack(false)}
            disabled={isPending}
          >
            Batal
          </Button>
          <Button
            variant={"default"}
            onClick={() => mutate(selectedRow?.email || "")}
            disabled={isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                Processing...
              </>
            ) : (
              "Ya, Login"
            )}
          </Button>
        </div>
      </Modal>

      <Modal show={showEditNIK} onClose={() => setShowEditNIK(false)}>
        <FormEditNIK
          closeModal={() => setShowEditNIK(false)}
          selectedRow={selectedRow}
        />
      </Modal>

      <Modal
        show={showInsertPendaftaran}
        onClose={() => setShowInsertPendaftaran(false)}
      >
        <FormInsertPendaftaran
          closeModal={() => setShowInsertPendaftaran(false)}
          selectedRow={selectedRow}
        />
      </Modal>
    </React.Fragment>
  );
}
